import { Component } from "react";
import { RotateCw } from "lucide-react";

export class AppErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("App crashed", error, info?.componentStack);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="app-error-screen" className="mx-auto flex min-h-[70vh] max-w-7xl flex-col items-start justify-center gap-6 px-5 pt-28 md:px-10">
        <p className="eyebrow text-[#D4AF37]">Intermission</p>
        <h1 className="font-display text-4xl font-bold text-white sm:text-5xl">Something went wrong</h1>
        <p className="max-w-lg text-base text-neutral-400">This page hit an unexpected snag. Reload to get back to the show.</p>
        <div className="flex flex-wrap gap-3">
          <button
            type="button"
            data-testid="app-error-reload-btn"
            onClick={() => window.location.reload()}
            className="btn-gold inline-flex items-center gap-2 rounded-full px-8 py-3 text-sm font-semibold uppercase tracking-[0.14em]"
          >
            <RotateCw className="h-4 w-4" /> Reload
          </button>
          <a href="/" data-testid="app-error-home-link" className="btn-ghost inline-flex items-center rounded-full px-8 py-3 text-sm font-medium uppercase tracking-[0.14em]">
            Go Home
          </a>
        </div>
      </div>
    );
  }
}
